import { useEffect, useState } from "react";
import Lenis from "lenis";
import { motion, AnimatePresence } from "framer-motion";
import "@/App.css";
import { LanguageProvider } from "./i18n";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Services from "./components/Services";
import Manifesto from "./components/Manifesto";
import Gallery from "./components/Gallery";
import PhotoQuote from "./components/PhotoQuote";
import BeforeAfter from "./components/BeforeAfter";
import Testimonials from "./components/Testimonials";
import Owners from "./components/Owners";
import Faq from "./components/Faq";
import ServiceArea from "./components/ServiceArea";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import ChatWidget from "./components/ChatWidget";
import { EstimatorProvider } from "./components/QuoteEstimator";

const Intro = () => (
  <motion.div
    key="intro"
    data-testid="intro-overlay"
    exit={{ y: "-100%" }}
    transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
    className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0D1B2A]"
  >
    <motion.div
      initial={{ opacity: 0, y: 24, scale: 0.94 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.7, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
      className="px-8 py-6 sm:px-12 sm:py-8"
    >
      <img
        src="/images/logo.png"
        alt="CasaFix Marina · Manitas y mantenimiento"
        className="w-64 sm:w-96"
        data-testid="intro-logo"
      />
    </motion.div>
    <motion.p
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.55 }}
      className="mt-3 text-[10px] font-semibold uppercase tracking-[0.4em] text-[#FAF6F0]/50 sm:text-xs"
    >
      We fix it · We clean it
    </motion.p>
  </motion.div>
);

function App() {
  const [intro, setIntro] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    const timer = setTimeout(() => setIntro(false), 1900);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      clearTimeout(timer);
    };
  }, []);

  return (
    <LanguageProvider>
      <EstimatorProvider>
      <div className="min-h-screen bg-[#FAF6F0] font-sans text-[#0D1B2A] antialiased">
        <div className="grain-overlay" aria-hidden="true" />
        <AnimatePresence>{intro && <Intro />}</AnimatePresence>
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <Manifesto />
          <Gallery />
          <BeforeAfter />
          <Testimonials />
          <PhotoQuote />
          <ServiceArea />
          <Owners />
          <Faq />
        </main>
        <Footer />
        <FloatingWhatsApp />
        <ChatWidget />
      </div>
      </EstimatorProvider>
    </LanguageProvider>
  );
}

export default App;
